/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { htmlSafe } from '@ember/template';

enum FeedbackOption {
  Manual = 'optionManual',
  Last = 'optionLast',
  First = 'optionFirst',
  Other = 'optionOther',
}

const FEEDBACK_OPTIONS = [
  {
    label: 'Manually select a winner for each attribute',
    value: FeedbackOption.Manual,
  },
  {
    label: 'Whichever attribute value was set last wins',
    htmlLabel: htmlSafe('Whichever attribute value was set <strong>last</strong> wins'),
    value: FeedbackOption.Last,
  },
  {
    label: 'Whichever attribute value was set first wins',
    htmlLabel: htmlSafe('Whichever attribute value was set <strong>first</strong> wins'),
    value: FeedbackOption.First,
  },
  {
    label: 'Other',
    value: FeedbackOption.Other,
  },
];

export default class MergeFeedbackForm extends Component<HelpModalComponentArgs> {
  FeedbackOptions = FEEDBACK_OPTIONS;

  get allOptionsFalse() {
    return FEEDBACK_OPTIONS.every((o) => !this[o.value]);
  }

  get submitDisabled() {
    if ((this.optionOther && this.otherDetail.trim().length < 1) || this.allOptionsFalse) {
      return true;
    }

    return false;
  }

  get disabledTooltipContent() {
    if (this.allOptionsFalse) {
      return 'Please select at least one option';
    }

    if (this.optionOther && this.otherDetail.trim().length < 1) {
      return 'Please provide feedback for "Other"';
    }

    return '';
  }

  @tracked optionManual = false;
  @tracked optionLast = false;
  @tracked optionFirst = false;
  @tracked optionOther = false;
  @tracked otherDetail = '';

  @action
  onSubmit(evt: Event) {
    evt.preventDefault();

    let optionPraise = FEEDBACK_OPTIONS.filter((o) => this[o.value])
      .map((o) => {
        if (o.value === FeedbackOption.Other) {
          return `Other: ${this.otherDetail.trim()}`;
        }

        return o.label;
      })
      .join('\r\n');

    this.args.onSubmit({
      criticism: `How would you like to merge people?`,
      praise: optionPraise,
    });
  }
}
